export default import.meta.ROLLDOWN_FILE_URL_jx5p2nJyF_X47WojhVH6OQ